<div class="upload-box">
  <div fxLayout="row" fxLayoutAlign="space-between start">
    <div>
      <strong>{{ cardHeading }} </strong>
      <i>{{ isRequired ? '(required)' : '(optional)' }}</i>
    </div>
    <div *ngIf="!isRequired">
      <button mat-icon-button color="primary">
        <mat-icon aria-hidden="true" (click)="ondeleteCardClick()"
          >delete</mat-icon
        >
      </button>
    </div>
  </div>
  <div *ngIf="helpText">
    {{ helpText }}
  </div>
  <div style="margin-top: 20px">
    <jsg-file-upload-detail-view
      *ngIf="
        uploadedDocument &&
          (uploadedDocument?.uploadStatus == DocumentUploadStatus.Uploading ||
            uploadedDocument?.uploadStatus == DocumentUploadStatus.Uploaded ||
            uploadedDocument?.uploadStatus == DocumentUploadStatus.Deleting) &&
          uploadedDocument?.document?.errors?.length == 0;
        else fileUploader
      "
      [guid]="uploadedDocument.documentId"
      [pages]="uploadedDocument.document.pages"
      [size]="uploadedDocument.document.size"
      [uploadedOn]="uploadedDocument.document.createdOn"
      [progress]="uploadedDocument.uploadProgress"
      [errors]="uploadedDocument.document?.errors"
      [name]="uploadedDocument.document.name"
      [uploadStatus]="uploadedDocument.uploadStatus"
      (cancelUpload)="onCancelUpload()"
      (deleteUpload)="onDeleteUpload($event)"
      (openFile)="onOpenFile($event)"
    ></jsg-file-upload-detail-view>
    <ng-template #fileUploader>
      <jsg-single-file-uploader
        [multiple]="false"
        [acceptedFileTypes]="['.pdf', '.PDF']"
        [errors]="uploadedDocument?.document?.errors"
        (selectFile)="onSelectFile($event)"
      >
      </jsg-single-file-uploader>
    </ng-template>
  </div>
</div>
